import React from 'react'

import {
  func,
  shape,
  string,
  array,
  object,
} from 'prop-types'

import FilterPill from 'Pods/Shared/FilterPill'

import { EMPTY_OBJECT } from 'Utils/stableDefaults'

import { productTypeLabel } from './productTypeOptions'

const DEFAULT_FILTERS = {
  query: '',
  status: [],
  fileType: [],
  productType: [],
}

function ActiveFilters({
  clearFilters,
  removeFilter,
  filters = DEFAULT_FILTERS,
  meta = EMPTY_OBJECT,
}) {
  const {
    query,
    status,
    fileType,
    productType,
    type,
  } = filters
  const availableFileTypes = meta?.availableFileTypes || []
  const fileTypeFilterEnabled = meta?.fileTypeFilterEnabled
  const showClearButton = !!(
    query || status.length || productType?.length || (fileTypeFilterEnabled && fileType.length)
  )

  return (
    <div className="products-filtering__active-filters">
      {!!meta && Object.keys(meta).length > 0 && (
        <span className="u-mr10">
          <span className="text-semibold">
            {`${meta.totalCount}/${meta.totalUnfilteredCount}`}
          </span>
          Filtered:
        </span>
      )}

      <span>
        {status && status.map((status) => (
          <FilterPill
            key={status}
            filter={{ value: status, text: status }}
            type="status"
            removeFilter={removeFilter}
          />
        ))}
        {productType && productType.map((value) => (
          <FilterPill
            key={value}
            filter={{ value, text: productTypeLabel(value) }}
            type="productType"
            removeFilter={removeFilter}
          />
        ))}
        {fileTypeFilterEnabled && fileType && fileType.map((fileTypeId) => (
          <FilterPill
            key={fileTypeId}
            filter={{
              value: fileTypeId,
              text: availableFileTypes.find((fileType) => fileTypeId === fileType.value)?.label || fileTypeId,
            }}
            type="fileType"
            removeFilter={removeFilter}
          />
        ))}
        {query.length !== 0 && query.split(' ').map((query) => (
          <FilterPill key={query} filter={{ value: query, text: query }} type="query" removeFilter={removeFilter} />
        ))}
        {type === 'collection' && (
          <FilterPill key="collection" filter={{ value: 'collection', text: 'Pack' }} type="type" />
        )}
      </span>

      {showClearButton && (
        <button
          onClick={clearFilters}
          className="btn btn-primary"
        >
          Clear all
        </button>
      )}
    </div>
  )
}

ActiveFilters.propTypes = {
  clearFilters: func.isRequired,
  removeFilter: func.isRequired,
  filters: shape({
    query: string,
    status: array,
    fileType: array,
    productType: array,
  }),
  meta: object,
}

export default ActiveFilters
